import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Users, FileText } from "lucide-react";

export function RecipientPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => api.get(`/letters/recipients?q=${encodeURIComponent(q)}`).then((r) => setItems(r.data)).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, [q, open]);
  return (
    <>
      <Button type="button" size="sm" variant="outline" onClick={() => setOpen(true)} data-testid="pick-recipient"><Users className="h-3.5 w-3.5 mr-1" />Choisir dans OMNIBAT</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="recipient-dialog">
          <DialogHeader><DialogTitle className="font-head">Destinataire existant</DialogTitle></DialogHeader>
          <Input autoFocus placeholder="Rechercher un client, fournisseur, collaborateur, prospect, partenaire…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="recipient-search" />
          <div className="max-h-80 overflow-y-auto divide-y">
            {items.map((r) => (
              <button key={`${r.source}-${r.source_id}`} type="button" className="w-full text-left px-2 py-2 hover:bg-slate-50" onClick={() => { onPick(r); setOpen(false); }} data-testid={`recipient-${r.source_id}`}>
                <span className="text-[10px] uppercase font-mono rounded bg-brand-50 text-brand-700 px-1.5 py-0.5 mr-2">{r.source}</span>
                <b className="text-sm">{r.nom || r.entreprise}</b>{r.entreprise && r.nom && <span className="text-xs text-slate-500"> · {r.entreprise}</span>}
                <span className="block text-xs text-slate-500">{[r.email, r.telephone, r.adresse].filter(Boolean).join(" · ")}</span>
              </button>
            ))}
            {!items.length && <p className="text-sm text-slate-400 p-3">Aucun résultat</p>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export function TemplatePicker({ onPick }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  useEffect(() => { if (open) api.get("/letters/templates/list?actif=true").then((r) => setItems(r.data)); }, [open]);
  return (
    <>
      <Button type="button" variant="outline" className="w-full" onClick={() => setOpen(true)} data-testid="use-template"><FileText className="h-4 w-4 mr-1.5" />Utiliser un modèle</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="template-dialog">
          <DialogHeader><DialogTitle className="font-head">Choisir un modèle</DialogTitle></DialogHeader>
          <div className="max-h-96 overflow-y-auto divide-y">
            {items.map((t) => (
              <button key={t.id} type="button" className="w-full text-left px-2 py-2 hover:bg-slate-50" onClick={() => { onPick(t); setOpen(false); }} data-testid={`template-${t.id}`}>
                <b className="text-sm">{t.nom}</b><span className="block text-xs text-slate-500">{t.type} · {t.objet}</span>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
